import React from 'react';
import Icon from './Icon';

/**
 * Star rating display. Renders 5 stars, filled up to `rating`.
 *
 * @param {number} rating - 1-5
 * @param {number} size - icon size in px (default 16)
 * @param {boolean} showEmpty - if true, empty stars use divider color; otherwise star color
 */
export default function StarRating({ rating, size = 16, showEmpty = true }) {
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((i) => (
        <Icon
          key={i}
          name={i <= rating ? 'star-filled' : 'star'}
          size={size}
          className={i <= rating ? 'text-star' : showEmpty ? 'text-bg-divider' : 'text-star'}
        />
      ))}
    </div>
  );
}
